var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          staticClass: "drawer-data-form-20210720",
          attrs: {
            "append-to-body": true,
            visible: _vm.drawer,
            "before-close": _vm.handleClose,
            size: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("BjDivider", [
                _vm._v(_vm._s(_vm.$t("CustomerFunction.onboardingFiles"))),
              ]),
              _c("BjPage", {
                ref: "BjPage",
                staticStyle: { "margin-top": "-40px" },
                attrs: {
                  "get-action": _vm.queryApi,
                  "query-params": _vm.queryParams,
                  serial: _vm.serial,
                  selection: _vm.selection,
                  "search-btn-hide": true,
                },
                on: {
                  handleSelectionChange: _vm.handleSelectionChange,
                  showSetting: _vm.SortableTable.show,
                  "header-dragend": _vm.SortableTable.handleHeaderDragend,
                  "header-contextmenu":
                    _vm.SortableTable.handleHeaderContextmenu,
                  afterFetchOriginalData: _vm.afterFetchOriginalData,
                },
                scopedSlots: _vm._u([
                  {
                    key: "tableOperation",
                    fn: function (tableOperationProp) {
                      return [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "main-btn",
                                attrs: {
                                  disabled: tableOperationProp.notSelected,
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.batchDownload()
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("batchDownloadText")))]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "tableColumn",
                    fn: function () {
                      return [
                        _vm._l(_vm.dropCols, function (col, index) {
                          return [
                            col.prop !== "bjTableAction"
                              ? _c("el-table-column", {
                                  key:
                                    "col_" +
                                    index +
                                    "_" +
                                    col.prop +
                                    "_" +
                                    (col.width || "auto"),
                                  attrs: {
                                    prop: col.prop,
                                    label: col.label,
                                    width: col.width || "auto",
                                    fixed: col.fixed || false,
                                    align: "center",
                                    "class-name": "item",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            false
                                              ? void 0
                                              : col.prop === "profitMargin"
                                              ? [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row[col.prop]
                                                      ) + " %"
                                                    ),
                                                  ]),
                                                ]
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("timeFilters")(
                                                        scope.row[col.prop],
                                                        scope.row[col.prop]
                                                      )
                                                    )
                                                  ),
                                                ]),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                            col.prop === "bjTableAction"
                              ? _c("el-table-column", {
                                  key:
                                    "col_" +
                                    index +
                                    "_" +
                                    col.prop +
                                    "_" +
                                    (col.width || "auto"),
                                  attrs: {
                                    prop: col.prop,
                                    label: col.label,
                                    width: col.width || "auto",
                                    fixed: col.fixed || "right",
                                    align: "center",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (props) {
                                          return [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "small",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadImageUrl(
                                                      props.row.url,
                                                      props.row.name
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("downloadText"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                })
                              : _vm._e(),
                          ]
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }